export default __webpack_public_path__ + "static/media/gratitude-banner.da441738.png";